import { observer } from "mobx-react";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import currentPortalStore from "../../stores/current-portal-store";
import customizationStore from "../../stores/customizations/customization-store";
import BasePageLayout from "../../components/layouts/base-page-layout/base-page-layout";

const LookAndFeelPage: React.FC = observer(() => {
    useEffect(() => {
        currentPortalStore.load();
        customizationStore.load();
    }, []);

    return (
        <BasePageLayout
            title="Settings"
            subTitles={['Portal', 'Look and Feel']}
            instruction={<>
                Customize the look and feel of your portals.
            </>}
        >
            <Outlet />
        </BasePageLayout>
    );
});

export default LookAndFeelPage;